<template>
  <div class="search-container">
    <el-form ref="form" inline>
      <el-form-item label="补货单号" label-width="80px">
        <el-input v-model="queryParam.orderNo" clearable></el-input>
      </el-form-item>
      <el-form-item label="入库单号" label-width="80px">
        <el-input v-model="queryParam.importNo" clearable></el-input>
      </el-form-item>
      <!--
      <el-form-item label="物流单号" label-width="80px">
        <el-input v-model="queryParam.sendLogisticsNo" clearable></el-input>
      </el-form-item>
      -->
      <el-form-item label-width="0">
        <el-button type="primary" @click="list(1)">
          <el-icon><search /></el-icon>查询
        </el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-container">
    <div class="table-header">
      <el-row :gutter="10">
        <el-col :span="10">
          <div class="table-title"><span></span>入库单列表</div>
        </el-col>
        <el-col :span="14">
          <div class="table-button-container">

          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="orders" border>
      <!--
      <el-table-column prop="sendLogisticsDate" label="发货时间"></el-table-column>
      -->
      <el-table-column prop="orderNo" label="补货单号"></el-table-column>
      <!--
      <el-table-column label="物流信息">
        <template #default="scope">
          <div>物流公司：{{scope.row.sendLogisticsCompany}}</div>
          <div>物流单号：{{scope.row.sendLogisticsNo}}</div>
          <div v-if="scope.row.sendLogisticsName">联系人：{{scope.row.sendLogisticsName}}</div>
          <div v-if="scope.row.sendLogisticsPhone">联系电话：{{scope.row.sendLogisticsPhone}}</div>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="importNo" label="入库单号"></el-table-column>
      <el-table-column label="油量">
        <template #default="scope">
          {{scope.row.oilNum + '箱'}}
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template #default="scope">
          {{scope.row.status === 0 ? '待收货' : scope.row.status === 2 ? '已收货' : '未知'}}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-link type="primary" href="javascript:;" @click="showDetail(scope.row)">详情</el-link>
          <el-link type="primary" href="javascript:;" :disabled="scope.row.status === 2" @click="showDetail(scope.row, true)">确认收货</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" v-model:current-page="pageIndex" @size-change="handleSizeChange"
                   :page-size="pageSize" :total="total" :page-sizes="pageSizes" :pager-count="5"
                   background
                   layout="sizes, prev, pager, next, total"></el-pagination>
  </div>

  <el-dialog :title="!isIn ? '详情' : '收货'" v-model="detailVisible" custom-class="dialog_width_large" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-table :data="details" border>
      <el-table-column type="index" label="序号"></el-table-column>
      <!--
      <el-table-column label="图片">
        <template #default="scope">
          <img :src="$utils.imageSrc(scope.row.pic)"/>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column label="类型">
        <template #default="scope">
          {{scope.row.type === 0 ? '油品' : '物料'}}
        </template>
      </el-table-column>
      <el-table-column label="数量">
        <template #default="scope">
          {{scope.row.orderQuantity + scope.row.unit}}
        </template>
      </el-table-column>
    </el-table>
    <el-button type="primary" v-if="isIn" @click="confirmIn" style="margin-top: 12px;">确认收货</el-button>
  </el-dialog>
</template>

<script>
export default {
  name: "入库单",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      pageSizes: [10, 20, 50],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      queryParam: {},
      orders: [],
      detailVisible: false,
      details: [],
      order: {},
      isIn: false
    }
  },
  methods: {
    list(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex
      }
      this.$utils.deleteEmptyProperty(this.queryParam)
      this.$apis.store.agentInList(this.pageIndex - 1, this.pageSize, this.queryParam).then(response => {
        let orders = response.data.data
        orders.forEach(item => item.oilNum = item.agentImportGoodsItemVOS.filter(subItem => subItem.type === 0).reduce((total, subItem) => total + subItem.realQuantity, 0))
        this.orders = orders
        this.total = response.data.total
      })
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.list()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.list(1)
    },
    showDetail(order, isIn) {
      this.detailVisible = true
      this.isIn = isIn
      this.order = {
        sn: order.sn
      }
      this.details = order.agentImportGoodsItemVOS
    },
    confirmIn() {
      this.$apis.store.agentInConfirm(this.order.sn).then(response => {
        if (response.status === 200) {
          this.$message({
            message: '收货成功',
            type: 'success'
          })
          this.detailVisible = false
          this.list()
        }
      })
    }
  },
  created() {
    if (this.currentUser.type === 1) {
      this.queryParam.agentSn = this.currentUser.sn
    }
    this.list()
  }
}
</script>

<style scoped>

</style>